import DomainCommon from "./common";

const DepartmentService = {

    list: function () {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getApiUrl()}/department`,
                params: undefined,
                resolve, reject
            });
        });
    },
};

export default DepartmentService
